import React, {lazy, Suspense} from "react";
import {Switch, Route, Redirect, useSearchParams} from "react-router-dom";

const Login = lazy(() => import("./views/auth/Login"));
const Signup = lazy(() => import("./views/auth/Signup"));
//import AuthedRoute, {EditorRoute, AdminRoute, BrandRoute} from "./views/auth/AuthedRoute"
const AuthedRoute = lazy(() => import("./views/auth/AuthedRoute"));
const AdminRoute = lazy(() => import("./views/auth/AdminRoute"));
const EditorRoute = lazy(() => import("./views/auth/EditorRoute"));
const BrandRoute = lazy(() => import("./views/auth/BrandRoute"));
const Home = lazy(() => import("./views/Home"));
const Admin = lazy(() => import("./views/Admin"));
const EditorDashboard = lazy(() => import("./views/EditorDashboard"));
const SupportTickets = lazy(() => import("./components/SupportTickets"));
const SingleConvPage = lazy(() => import("./components/SupportTickets/SingleConvPage"));
const MyVotes = lazy(() => import("./views/MyVotes"));
const ReaderDashboard = lazy(() => import("./views/ReaderDashboard"));
const About = lazy(() => import("./views/About"));
const Unsubscribe = lazy(() => import("./views/Unsubscribe"));
const NewEditor = lazy(() => import("./views/NewEditor"));
const QuillEditor = lazy(() => import("./views/QuillEditor"));
const OfflineInvitationRedirect = lazy(() => import("./views/QuillEditor/OfflineInvitationRedirect"));

const DraftActivity = lazy(() => import("./views/DraftActivity"));
const Baa = lazy(() => import("./views/Baa"));
const BrandLogin = lazy(() => import("./views/auth/BrandLogin"));
const IceBreakerQuiz = lazy(() => import("./views/brands/IceBreakerQuiz"));
const UserStats = lazy(() => import("./views/stats/UserStats"));
const StoryStats = lazy(() => import("./views/stats/StoryStats"));
const Profile = lazy(() => import("./views/Profile"));
const Services = lazy(() => import("./views/ServicesDashboard"));
const RedirectProofOfUsefulness = lazy(() => import("./views/RedirectProofOfUsefulness"));

const UserOnboarding = lazy(() => import("./views/UserOnboarding"));
const Bookmarks = lazy(() => import("./views/Bookmarks"));
const NewDraft = lazy(() => import("./views/NewDraft"));
const TranslatedEditor = lazy(() => import("./views/TranslatedEditor"));
const Editor = lazy(() => import("./views/Editor"));
const SloggingReordering = lazy(() => import("./views/SloggingReordering"));
const SponsorOnboarding = lazy(() => import("./views/SponsorOnboarding"));
const SponsorAd = lazy(() => import("./views/SponsorAd"));
const SponsorDashboard = lazy(() => import("./views/SponsorDashboard"));
const Subscriptions = lazy(() => import("./views/Subscriptions"));
const NotificationDashboard = lazy(() => import("./views/NotificationDashboard"));
const EditCompanyPageAdmin = lazy(() => import("./components/EditCompanyPageAdmin"));
const StartupMarketing = lazy(() => import("./components/Brands/learn-more/StartupMarketing"));
const ContentMarketing = lazy(() => import("./components/Brands/learn-more/ContentMarketing"));
const AdminNotifications = lazy(() => import("./views/admin/components/NotificationsAdmin"));
const BrandSignUp = lazy(() => import("./views/auth/BrandSignUp"));
const StartupPackage = lazy(() => import("./views/brands/StartupPackage"));
const UserDashboardNotes = lazy(() => import("./components/StickyNotes/UserDashboardNotes"));
const GptSystemPrompts = lazy(() => import("./views/GptSystemPrompts"));

import Loading from "./components/Loading";

const Routes = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/reader" />} />
        <Route
          exact
          path="/new"
          component={() => {
            const queryParams = new URLSearchParams(window?.location?.search);
            const template = queryParams.get("template");

            const url = new URL("https://hackernoon.com/new");
            if (template) {
              url.searchParams.append("template", template);
            }

            window.location.href = url?.toString();
            return null;
          }}
        />
        <Route
          exact
          path="/blogging-templates"
          component={() => {
            window.location.href = "https://hackernoon.com/blogging-templates";
            return null;
          }}
        />
        <Route exact path="/slogging/:id" component={SloggingReordering} />
        <Route exact path="/sponsor" component={SponsorOnboarding} />
        <Route exact path="/sponsor/ad" component={SponsorAd} />
        <Route
          path="/login*"
          // component={Login}
          component={() => {
            window.location.href = "https://hackernoon.com/login?redirect=app";
            return null;
          }}
        />
        <Route
          exact
          path="/signup"
          // component={Signup}
          component={() => {
            window.location.href = "https://hackernoon.com/signup";
            return null;
          }}
        />
        <Route exact path="/unsubscribe" component={Unsubscribe} />
        <Route exact path="/dashboard/comments" render={() => <Redirect to="/writer/comments" />} />
        <Route exact path="/newsletter-stats" render={() => <Redirect to="/stats" />} />
        <Route exact path="/brandlogin" component={BrandLogin} />
        <Route exact path="/brandsignup" component={BrandSignUp} />
        <Route exact path="/brands/ice-breaker" render={() => <Redirect to="/brand/ice-breaker" />} />
        <Route exact path="/dashboard/comments" render={() => <Redirect to="/writer/comments" />} />

        <AuthedRoute exact path="/drafts/:id" component={Editor} />
        <AuthedRoute exact path="/mobile/:id" component={Editor} />
        <AuthedRoute exact path="/activities/:draftId" component={DraftActivity} />
        <AuthedRoute path="/company" component={EditCompanyPageAdmin} />
        <AuthedRoute path="/writer" component={Home} />
        <AuthedRoute exact path="/sponsor/dashboard" component={SponsorDashboard} />
        <AuthedRoute exact path="/my-votes" component={MyVotes} />
        <AuthedRoute exact path="/stats" component={UserStats} />
        <AuthedRoute exact path="/stats/:id" component={StoryStats} />
        <AuthedRoute
          path="/profile"
          component={Profile}
          // component={() => {
          //   window.location.href = "https://hackernoon.com/settings";
          //   return null;
          // }}
        />

        <Route path="/services" component={Services} />
        <Route path="/proof-of-usefulness" component={RedirectProofOfUsefulness} />

        {/* <AuthedRoute path="/boot" component={UserOnboarding} /> */}
        <AuthedRoute
          exact
          path="/boot/handle"
          // component={Signup}
          component={() => {
            window.location.href = "https://hackernoon.com/onboarding";
            return null;
          }}
        />

        <AuthedRoute
          exact
          path="/boot/tags"
          // component={Signup}
          component={() => {
            window.location.href = "https://hackernoon.com/onboarding";
            return null;
          }}
        />

        <AuthedRoute
          exact
          path="/boot"
          // component={Signup}
          component={() => {
            window.location.href = "https://hackernoon.com/onboarding";
            return null;
          }}
        />
        <AuthedRoute exact path="/bookmarks" component={Bookmarks} />
        <AuthedRoute path="/subscriptions" component={Subscriptions} />
        <AuthedRoute exact path="/reader" component={ReaderDashboard} />
        <AuthedRoute exact path="/notifications" component={NotificationDashboard} />
        <AuthedRoute exact path="/about" component={About} />
        <AuthedRoute exact path="/inbox" component={SupportTickets} />
        <AuthedRoute exact path="/inbox/:ticketId" component={SingleConvPage} />

        <Route exact path="/my-notes" render={() => <Redirect to="/inbox" />} />

        <AuthedRoute exact path="/sticky-notes" component={UserDashboardNotes} />
        <AuthedRoute exact path="/system-prompts" component={GptSystemPrompts} />

        <BrandRoute exact path="/brand" component={Baa} />
        <BrandRoute exact path="/brand/startup-marketing" component={StartupMarketing} />
        <BrandRoute exact path="/brand/content-marketing" component={ContentMarketing} />
        <BrandRoute exact path="/brand/baa" component={Baa} />
        <BrandRoute exact path="/brand/startup-package" component={StartupPackage} />
        <BrandRoute exact path="/brand/ice-breaker" component={IceBreakerQuiz} />

        <EditorRoute exact path="/translated-story/:id" component={TranslatedEditor} />
        <EditorRoute exact path="/editor" component={EditorDashboard} />
        <EditorRoute exact path="/editor2" component={NewEditor} />
        <AuthedRoute exact path="/articles/:id" component={QuillEditor} />
        <Route exact path="/articles-invitation" component={OfflineInvitationRedirect} />
        <EditorRoute path="/admin/notifications" component={AdminNotifications} />
        <EditorRoute path="/admin" component={Admin} />
      </Switch>
    </Suspense>
  );
};

export default Routes;
